import type {
  RenameUploadMutation,
  RenameUploadMutationVariables,
} from '../generated';

import { gql, TypedDocumentNode } from '@apollo/client';

export const RENAME_UPLOAD: TypedDocumentNode<
  RenameUploadMutation,
  RenameUploadMutationVariables
> = gql`
  mutation RenameUpload($id: ID!, $filename: String!) {
    renameUpload(id: $id, filename: $filename) {
      id
      resourceId
      filename
      createdAt
      documentId
      documentPath
      url
      isEncrypted
    }
  }
`;
